import React from 'react';
import { Form, SemanticWIDTHS } from 'semantic-ui-react';

export type Props = Readonly<{
    alumnos: ReadonlyArray<{
        numeroDeMatricula: number;
        nombre: string;
    }>;
    numeroDeMatricula: number;
    alSeleccionarAlumno: (numeroDeMatricula: number) => void;
    width: SemanticWIDTHS;
}>;

export class SelectorDeAlumnos extends React.PureComponent<Props> {
    public render() {
        const { alumnos, numeroDeMatricula, alSeleccionarAlumno, width } = this.props;

        return (
            <Form.Select
                label='Alumno'
                required
                search
                deburr
                options={alumnos.map(alu => ({
                    key: alu.numeroDeMatricula,
                    value: alu.numeroDeMatricula,
                    text: alu.nombre,
                }))}
                value={numeroDeMatricula}
                onChange={(_, { value }) => alSeleccionarAlumno(value as number)}
                width={width}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/modulos/Orientacion/componentes/SelectorDeAlumnos.tsx